import { Routes } from "@angular/router";

export const importacionRoutes: Routes = [
  {
    path: "imp_inicio",
    loadComponent: () => import("./inicio/importacion.component"),
    data: {
      codmod: "IMP",
      icon: "home",
    },
  },
  {
    path: "imp_alta_baja",
    loadComponent: () => import("./alta-baja/alta-baja.component"),
    data: {
      codmod: "IMP",
      icon: "upload_file",
    },
  },
  {
    path: "imp_ajuste_salarios",
    loadComponent: () => import("./ajuste-salario/ajuste-salario.component"),
    data: {
      codmod: "IMP",
      icon: "upload_file",
    },
  },
  {
    path: "imp_novedades_liquidacion",
    loadComponent: () => import("./novedades-liquidacion/novedades-liquidacion.component"),
    data: {
      codmod: "IMP",
      icon: "upload_file",
    },
  },
];
